import NewInputField from "../../../DesignSystem/Inputs/NewInputField";
import NewDateField from "../../../DesignSystem/Inputs/NewDateField";
import RepeatableInputField from "../../../DesignSystem/Inputs/RepeatableInputField";
import ToggleButton from "../../../DesignSystem/Inputs/ToggleButton";
import Checkbox from "../../../DesignSystem/Inputs/Checkbox";
import BorderlessCheckboxGroup from "../../../DesignSystem/SelectionControls/BorderlessCheckboxGroup";
import Divider from "../../../DesignSystem/Layout/Divider";
import {
  CONTRACT_APPOINTMENT_OPTIONS,
  CONTRACT_PERMISSION_OPTIONS,
  CONTRACT_RATE_FIELDS,
  CONTRACT_SUPERVISION_FEE_OPTIONS,
  buildSupervisionFeeMap,
  getSelectedSupervisionFees,
  DEFAULT_CONTRACT_RATES,
} from "./contractDetailsDefaults";

const LtdCompanyDetails = ({ values, onChange }) => {
  const update = (field, value) => onChange({ ...values, [field]: value });
  const updateRate = (field, value) =>
    update("rates", { ...(values.rates || {}), [field]: value });
  return (
    <div className="column gap-m px-xs">
      <div className="FP_Subtitle_Semibold text-primary-1">
        Ltd Company Contract
      </div>
      <NewInputField
        id="ltd-ar-name"
        label="AR Name"
        value={values.tradingName}
        onChange={(e) => update("tradingName", e.target.value)}
      />
      <div className="grid2 gap-m">
        <NewDateField
          id="ltd-start-date"
          label="Contract takes effect from"
          value={values.contractStartDate}
          onChange={(e) => update("contractStartDate", e.target.value)}
        />
        <NewInputField
          id="ltd-company-number"
          label="Company Registered Number"
          value={values.fcaNumber}
          onChange={(e) => update("fcaNumber", e.target.value)}
        />
      </div>
      <NewInputField
        id="ltd-company-address"
        label="Company Registered Address"
          value={values.businessAddress?.fullAddress || ""}
          onChange={(e) =>
            update("businessAddress", { fullAddress: e.target.value })
          }
      />
      <BorderlessCheckboxGroup
        label="Appointment and Status"
        required
        options={CONTRACT_APPOINTMENT_OPTIONS}
        values={values.appointmentStatuses || []}
        onChange={(value) => update("appointmentStatuses", value)}
        columns={1}
      />
      <div className="fit-column gap-xs">
        <div className="FP_Content_Semibold text-black">
          Law of the Contract
        </div>
        <RepeatableInputField
          id="ltd-law-name"
          label="Name of Person"
          required
          values={values.lawOfContractNames || [values.lawOfContractName || ""]}
          onChange={(names) => update("lawOfContractNames", names)}
        />
      </div>
      <BorderlessCheckboxGroup
        label="Supervision Fee"
        required
        options={CONTRACT_SUPERVISION_FEE_OPTIONS}
        values={getSelectedSupervisionFees(values.supervisionFees)}
        onChange={(selected) =>
          update("supervisionFees", buildSupervisionFeeMap(selected))
        }
        columns={1}
      />
      <BorderlessCheckboxGroup
        label="Permitted Activities"
        required
        options={CONTRACT_PERMISSION_OPTIONS}
        values={values.permittedActivities || []}
        onChange={(value) => update("permittedActivities", value)}
        columns={1}
      />
      <BorderlessCheckboxGroup
        label="Commission and Fees"
        required
        options={["Broker Fees", "Initial and ongoing adviser charges"]}
        values={values.commissionFeeTypes || []}
        onChange={(value) => update("commissionFeeTypes", value)}
        columns={1}
      />
      <div className="fit-column gap-xs">
        <div className="FP_Content_Semibold text-black">IFA Rates</div>
        <div className="row gap-s align-center">
          <ToggleButton
            checked={values.useDefaultRates === true}
            onChange={(checked) =>
              onChange({
                ...values,
                useDefaultRates: checked,
                rates: checked ? { ...DEFAULT_CONTRACT_RATES } : values.rates,
              })
            }
          />
          <span className="FP_Content">Use Default Rates</span>
        </div>
        <div className="grid2 gap-m">
          {CONTRACT_RATE_FIELDS.filter(({ type }) => type === "percentage").map(
            ({ key, label }) => (
              <NewInputField
                key={key}
                id={`ltd-${key}-rate`}
                label={`${label} %`}
                type="number"
                value={values.rates?.[key] ?? ""}
                onChange={(e) => updateRate(key, e.target.value)}
              />
            ),
          )}
        </div>
      </div>
      <Checkbox
        checked={values.approved === true}
        id="ltd-approved"
        label="I confirm the contract details are ready for review."
        onChange={(e) => update("approved", e.target.checked)}
      />
    </div>
  );
};

export default LtdCompanyDetails;
